import i18n from "src/i18n/config";

const CAMPAIGN_LABEL_KEYS: Record<string, string> = {
  "Customer Lifecycle Campaigns": "customerLifecycleCampaigns",
  "Informational & Brand Content": "informationalBrandContent",
  "Promotional Campaigns": "promotionalCampaigns",
  "Behavioral Campaigns": "behavioralCampaigns",
  Custom: "custom",
  "Welcome Series": "welcomeSeries",
  "Abandoned Cart Recovery": "abandonedCartRecovery",
  "Browse Abandonment": "browseAbandonment",
  "Post-Purchase Follow-Up": "postPurchaseFollowUp",
  Behavioral: "behavioral",
  "Win-Back Campaigns": "winBackCampaigns",
  "Brand Storytelling Series": "brandStorytellingSeries",
  "Style Guides / Lookbooks": "styleGuidesLookbooks",
  "How-To Content": "howToContent",
  "Newsletter or Product Digest": "newsletterOrProductDigest",
  "Flash Sale Alerts": "flashSaleAlerts",
  "Seasonal/Holiday Promotions": "seasonalHolidayPromotions",
  "New Product Launches": "newProductLaunches",
  "Exclusive VIP Offers": "exclusiveVipOffers",
  "Price Drop Alerts": "priceDropAlerts",
  "Product Recommendation Emails": "productRecommendationEmails",
  "Birthday or Anniversary Emails": "birthdayOrAnniversaryEmails",
  "Review & UGC Requests": "reviewUgcRequests",
};

export const translateCampaignLabel = (title: string): string => {
  const key = CAMPAIGN_LABEL_KEYS[title];
  return key ? i18n.t(`campaignCategories.${key}`) : title;
};
